import { InsightsCard, InsightsDividerList, InsightsDividerRow } from "./InsightsCard";
import { sanitizeValue, toTitleCase } from "./insightUtils";
import { useCitation, getCitationForField } from "./CitationContext";

export interface IdentificationCardExtraction {
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

export function IdentificationCardInsights({
  data,
  citations,
}: {
  data: IdentificationCardExtraction;
  citations?: Record<string, unknown> | null;
}) {
  const { showCitation } = useCitation();

  const handleFieldClick = (fieldPath: string) => {
    const citation = getCitationForField(citations, fieldPath);
    if (citation) showCitation(citation);
  };

  return (
    <div className="px-6 pb-6 space-y-4">
      <InsightsCard title="ID details" noPadding>
        <InsightsDividerList>
          <InsightsDividerRow
            label="First name"
            value={toTitleCase(sanitizeValue(data.first_name))}
            onClick={
              getCitationForField(citations, "first_name")
                ? () => handleFieldClick("first_name")
                : undefined
            }
          />
          <InsightsDividerRow
            label="Last name"
            value={toTitleCase(sanitizeValue(data.last_name))}
            onClick={
              getCitationForField(citations, "last_name")
                ? () => handleFieldClick("last_name")
                : undefined
            }
          />
          <InsightsDividerRow
            label="Address"
            value={toTitleCase(sanitizeValue(data.address))}
            onClick={
              getCitationForField(citations, "address")
                ? () => handleFieldClick("address")
                : undefined
            }
          />
          <InsightsDividerRow
            label="City"
            value={toTitleCase(sanitizeValue(data.city))}
            onClick={
              getCitationForField(citations, "city") ? () => handleFieldClick("city") : undefined
            }
          />
          <InsightsDividerRow
            label="State"
            value={toTitleCase(sanitizeValue(data.state))}
            onClick={
              getCitationForField(citations, "state") ? () => handleFieldClick("state") : undefined
            }
          />
          <InsightsDividerRow
            label="Zip"
            value={sanitizeValue(data.zip)}
            onClick={
              getCitationForField(citations, "zip") ? () => handleFieldClick("zip") : undefined
            }
          />
        </InsightsDividerList>
      </InsightsCard>
    </div>
  );
}
